import styled, { useTheme } from 'styled-components'
import { useRef, useEffect, useState, useContext } from 'react'
import { ChartContext } from 'components/DaylightChart/UseChartContext'
import { useTransition, animated } from '@react-spring/web'

// TODO: Text should be html child
const ChartNote = ({
  position,
  textPosition,
  text,
  show,
  hideArrow,
  inverted,
}: {
  position: [number, number]
  textPosition?: [number, number]
  text: string
  show?: boolean
  hideArrow?: boolean
  inverted?: boolean
}) => {
  const theme = useTheme()
  const chartDimensions = useContext(ChartContext)
  const chartCenter = [chartDimensions.width / 2, chartDimensions.height / 2]
  const [textRef, setTextRef] = useState<HTMLDivElement | null>(null)
  const [textSize, setTextSize] = useState<[number, number]>([0, 0])
  const svgSize = [200, 200]
  const svgCenter = [svgSize[0] / 2, svgSize[1] / 2]
  const distanceFromArrowStart = 6
  const tPos = textPosition || [0, 0]
  const dist = -5
  const txtPos =
    tPos[0] < position[0] && !hideArrow
      ? [tPos[0] - position[0] - textSize[0], tPos[1] - position[1]]
      : [tPos[0] - position[0], tPos[1] - position[1]]

  const transitions = useTransition(show, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  })

  const textPos = [
    position[0] > chartCenter[0]
      ? -textSize[0] - dist - distanceFromArrowStart
      : dist + distanceFromArrowStart,
    position[1] > chartCenter[1]
      ? -textSize[1] * 0.5 - dist
      : dist - textSize[1] * 0.5,
  ]

  const arrowStartPos = [
    svgCenter[0] + (position[0] > chartCenter[0] ? -dist : dist),
    svgCenter[1] + (position[1] > chartCenter[1] ? -dist : dist),
  ]

  useEffect(() => {
    if (textRef) {
      const width = textRef.offsetWidth
      const height = textRef.offsetHeight
      setTextSize([width, height])
    }
  }, [textRef])

  console.log(text, textSize)

  return transitions(
    (style, item) =>
      item && (
        <Container
          style={{
            left: `${position[0]}px`,
            top: `${position[1]}px`,
            opacity: style.opacity,
            // transform: style.opacity.to(v => `translate3d(0, ${v * 10}px, 0)`),
          }}
        >
          <Text
            inverted={inverted}
            ref={setTextRef}
            style={{
              textAlign: tPos[0] < position[0] ? 'right' : 'left',
              transform: textPosition
                ? `translate(${txtPos[0]}px, ${txtPos[1]}px)`
                : `translate(${textPos[0]}px, ${textPos[1]}px)`,
            }}
          >
            {text}
          </Text>
          {!hideArrow && (
            <Svg width={svgSize[0]} height={svgSize[1]}>
              <defs>
                <marker
                  id='arrowHead'
                  orient='auto'
                  markerWidth='10'
                  markerHeight='10'
                  refX='5'
                  refY='5'
                  viewBox='0 0 10 10'
                >
                  <path
                    d='M 0,0 L 5,5 L 0,10'
                    fill='transparent'
                    stroke={theme.backgroundColorInverted}
                  />
                </marker>
              </defs>
              <Line
                markerEnd='url(#arrowHead)'
                d={`M${arrowStartPos[0] + tPos[0] - position[0]} ${
                  arrowStartPos[1] + textSize[1] * 0.5 + txtPos[1]
                } L${svgCenter[0]} ${svgCenter[1]}`}
              />
            </Svg>
          )}
        </Container>
      )
  )
}

const Container = styled(animated.div)`
  position: absolute;
`

const Line = styled.path`
  stroke: #222426;
  stroke-width: 1px;
  fill: none;
`

const Text = styled.div<{ inverted?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 150px;
  line-height: 1.2;
  color: ${({ inverted, theme }) =>
    inverted ? '#ffffff' : '#121212'};
  font-size: 0.85em;
  text-shadow: ${({ inverted, theme }) =>
    inverted
      ? `1px 1px 0 #121212, -1px 1px 0 #121212, -1px -1px 0 #121212, 1px -1px 0 #121212`
      : `1px 1px 0 #ffffff, -1px 1px 0 #ffffff, -1px -1px 0 #ffffff, 1px -1px 0 #ffffff`};

  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 0.75em;
  }
`

const Svg = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
`

export default ChartNote
